export const SET_IS_DIALOG_OPEN = 'confirmActionComponent.setIsDialogOpen'

export function setIsDialogOpen(payload: boolean) {
  return {
    type: SET_IS_DIALOG_OPEN,
    payload
  } as const
}

export type ConfirmActionAction = ReturnType<typeof setIsDialogOpen>
